import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Success from "../toast/Success";
import { toast } from "react-toastify";
import APIService from "../../services/APIService";
import { Link } from "react-router-dom";
import { AuthUserContext } from "../../context/AuthUserContext";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  z-index: 99999;
`;

const PopupForm = styled.div`
  background: var(--bg-200);
  padding: 20px 0;

  max-width: 90%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
  position: relative;
  border-radius: 14px;
  @media (min-width: 768px) {
    width: 500px;
  }
`;
const Form = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  //gap: 8px;
  margin: 10px 0;
`;
const FormWrapper = styled.div`
  min-width: 90%;
  max-width: 90%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Title = styled.h2`
  font-size: var(--font-size-xlarge);
  text-align: center;
  font-weight: 400;
  padding: 0;
  margin: 0;
  color: var(--text-200);
  text-transform: capitalize;
  margin-bottom: var(--spacing-sm);
  padding-bottom: var(--spacing-xs);

  border-bottom: 1px solid var(--bg-300);
`;
const TopDiv = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 90%;
  margin: 0 auto;
  flex-direction: column;
`;

const TopTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: var(--font-size-large);
  margin: 12px 0;
`;
const Text = styled.p`
  text-align: left;
`;

const CloseButton = styled.div`
  background: none;
  border: none;
  font-size: 20px;
  font-weight: bold;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;

  &:hover {
    color: var(--text-100);
  }
`;

const SubscribeButton = styled.button`
  width: 100%;
  height: 50px;
  background-color: var(--text-200);
  text-transform: capitalize;
  border-radius: 8px;
  border-color: var(--text-200);
  &:hover {
    background-color: var(--bg-200);
    color: var(--text-200);
  }
`;
const Input = styled.input`
  outline: none;
  padding: var(--spacing-sm) 0 var(--spacing-sm) var(--spacing-xs);
  border: 1px solid #ccc;
  width: calc(100% - 8px);
  font-size: var(--font-size-small);
  color: var(--text-200);
  background-color: var(--bg-200);
  margin: var(--spacing-xxs) 0 var(--spacing-xs) 0;
  ::placeholder {
    font-size: var(--font-size-small);
    color: var(--p-color);
  }

  border-radius: 4px;
`;
const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 4px 0;
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  margin: 8px 0;
  gap: 4px;
`;
const ListText = styled.span`
  font-size: 14px;
  color: var(--text-100);
`;

const DisclaimerText = styled(Text)`
  font-size: var(--font-size-small);
  display: inline;
`;

const CustomLink = styled(Link)`
  color: var(--text-color);
  font-size: var(--font-size-small);
  font-weight: bold;
  display: inline;
  @media (min-width: 765px) {
    margin: 0;
  }
`;

const showSuccessNotification = (text) => {
  toast(<Success text={text} />, {
    position: "top-left",
    autoClose: 5000, // Obaveštenje će se automatski skloniti nakon 5 sekundi
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: "custom-toast-success",
    progressClassName: "custom-progress-bar",
  });
};

const SubscriptionPopup = () => {
  const { t } = useTranslation();
  const { authTokens } = useContext(AuthUserContext);
  const [isVisible, setIsVisible] = useState(false);
  const [email, setEmail] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      // Proveri da li je popup već prikazan u ovoj sesiji
      if (!sessionStorage.getItem("subscriptionPopupShown")) {
        setIsVisible(true);
        sessionStorage.setItem("subscriptionPopupShown", "true"); // Obeleži popup kao prikazan
      }
      window.removeEventListener("scroll", handleScroll);
    };

    // Dodaj event listener za skrol
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateEmail(email)) {
      return;
    }
    try {
      const response = await APIService.subscribe(email);
      showSuccessNotification(t("NOTIFICATIONS.SUCCESS"));
      setEmail("");
      setIsVisible(false);
    } catch (error) {
      if (error.response) {
      }
    }
  };

  const validateEmail = (email) => {
    const trimmedEmail = email.trim();
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(trimmedEmail).toLowerCase());
  };

  return (
    <Overlay isVisible={isVisible}>
      <PopupForm>
        <CloseButton onClick={handleClose}>
          <svg
            width="24px"
            height="24px"
            viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="var(--text-100)"
              d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"
            />
          </svg>
        </CloseButton>
        {/* <Title>{t("SUBSCRIPTION.TITLE_POPUP")}</Title> */}
        <Title>Newsletter</Title>
        <TopDiv>
          <TopTitle>
            <svg
              width="30px"
              height="30px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 7.00005L10.2 11.65C11.2667 12.45 12.7333 12.45 13.8 11.65L20 7"
                stroke="var(--text-100)"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <rect
                x="3"
                y="5"
                width="18"
                height="14"
                rx="2"
                stroke="var(--text-100)"
                strokeWidth="1"
                strokeLinecap="round"
              />
            </svg>
            <h3>Would you like to receive our newsletter?</h3>
          </TopTitle>
          <Text>Enter your email address here to receive:</Text>
          <List>
            <ListItem>
              <svg
                fill="var(--text-100)"
                width="12px"
                height="12px"
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M745.472 352.256c-8.192-4.096-20.48-4.096-28.672 0L462.848 614.4 344.064 491.52c-8.192-8.192-20.48-8.192-28.672 0s-8.192 20.48-4.096 28.672L446.464 655.36h4.096s4.096 0 4.096 4.096h16.384s4.096 0 4.096-4.096h4.096l270.335-274.432c0-8.192 0-20.48-4.096-28.672z" />
                <path d="M512 1024C229.376 1024 0 794.624 0 512S229.376 0 512 0s512 229.376 512 512-229.376 512-512 512zm0-983.04C253.952 40.96 40.96 253.952 40.96 512S253.952 983.04 512 983.04 983.04 770.048 983.04 512 770.048 40.96 512 40.96z" />
              </svg>
              <ListText>News</ListText>
            </ListItem>
            <ListItem>
              <svg
                fill="var(--text-100)"
                width="12px"
                height="12px"
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M745.472 352.256c-8.192-4.096-20.48-4.096-28.672 0L462.848 614.4 344.064 491.52c-8.192-8.192-20.48-8.192-28.672 0s-8.192 20.48-4.096 28.672L446.464 655.36h4.096s4.096 0 4.096 4.096h16.384s4.096 0 4.096-4.096h4.096l270.335-274.432c0-8.192 0-20.48-4.096-28.672z" />
                <path d="M512 1024C229.376 1024 0 794.624 0 512S229.376 0 512 0s512 229.376 512 512-229.376 512-512 512zm0-983.04C253.952 40.96 40.96 253.952 40.96 512S253.952 983.04 512 983.04 983.04 770.048 983.04 512 770.048 40.96 512 40.96z" />
              </svg>
              <ListText>Pre-launches</ListText>
            </ListItem>
            <ListItem>
              <svg
                fill="var(--text-100)"
                width="12px"
                height="12px"
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M745.472 352.256c-8.192-4.096-20.48-4.096-28.672 0L462.848 614.4 344.064 491.52c-8.192-8.192-20.48-8.192-28.672 0s-8.192 20.48-4.096 28.672L446.464 655.36h4.096s4.096 0 4.096 4.096h16.384s4.096 0 4.096-4.096h4.096l270.335-274.432c0-8.192 0-20.48-4.096-28.672z" />
                <path d="M512 1024C229.376 1024 0 794.624 0 512S229.376 0 512 0s512 229.376 512 512-229.376 512-512 512zm0-983.04C253.952 40.96 40.96 253.952 40.96 512S253.952 983.04 512 983.04 983.04 770.048 983.04 512 770.048 40.96 512 40.96z" />
              </svg>
              <ListText>Products</ListText>
            </ListItem>
            <ListItem>
              <svg
                fill="var(--text-100)"
                width="12px"
                height="12px"
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M745.472 352.256c-8.192-4.096-20.48-4.096-28.672 0L462.848 614.4 344.064 491.52c-8.192-8.192-20.48-8.192-28.672 0s-8.192 20.48-4.096 28.672L446.464 655.36h4.096s4.096 0 4.096 4.096h16.384s4.096 0 4.096-4.096h4.096l270.335-274.432c0-8.192 0-20.48-4.096-28.672z" />
                <path d="M512 1024C229.376 1024 0 794.624 0 512S229.376 0 512 0s512 229.376 512 512-229.376 512-512 512zm0-983.04C253.952 40.96 40.96 253.952 40.96 512S253.952 983.04 512 983.04 983.04 770.048 983.04 512 770.048 40.96 512 40.96z" />
              </svg>
              <ListText>Information</ListText>
            </ListItem>
          </List>
        </TopDiv>
        <Form onSubmit={handleSubmit}>
          <FormWrapper>
            <Input
              type="email"
              placeholder={t("PLACEHOLDERS.EMAIL")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <SubscribeButton type="submit">
              {t("BUTTONS.SUBMIT")}
            </SubscribeButton>
          </FormWrapper>
        </Form>
        <div style={{ textAlign: "left", width: "90%", margin: "0 auto" }}>
          <DisclaimerText>
            By subscribing, you agree that SnusCo handles your personal data in
            accordance with our{" "}
          </DisclaimerText>
          <CustomLink>privacy policy.</CustomLink>
        </div>
      </PopupForm>
    </Overlay>
  );
};

export default SubscriptionPopup;
